import React, { useState } from "react";
import classes from "./DateIncrementer.module.css";
import { formatDateLongString, addYearsToDate, dateDifference  } from "../../../shared/utils/dateUtils";
import classes2 from "../../general/inputs/DateInput.module.css";
import InputWrapper from "../../general/InputWrapper";

const DateIncrementer = ({inputs, updateInput, label }) => {
  
  
  const partialRetirementDate = new Date(inputs.memberInfo.dateOfPartRet);
  const defaultFullRetirementDate  = new Date(inputs.memberInfo.dateOfFullRet);
  const memberDateOfBirth = new Date(inputs.memberInfo.dateOfBirth);
  const maxRetirementAge = 80;
  const maxMemberBirthday = addYearsToDate(memberDateOfBirth, maxRetirementAge);
  const [selectedDate, setSelectedDate] = useState(defaultFullRetirementDate);
  const options = Array.from({ length: 8 }, (_, i) => addYearsToDate(partialRetirementDate, i + 1)).filter(date => date <= maxMemberBirthday);

  const handleChange = (event) => {
    const newDate = new Date(event.target.value);
    setSelectedDate(newDate);
    updateInput("memberInfo", "dateOfFullRet", newDate.toISOString().split("T")[0]);
  };

  return (
    
    <div className={classes.date_incrementer_container}>
      <h3> {label}</h3>
      <section className = {classes2.input_container}> 
      <select value={selectedDate.toISOString().split("T")[0]} onChange={handleChange}>
        {options.map((date) => (
          <option key={date.toISOString()} value={date.toISOString().split("T")[0]}>
            {formatDateLongString(date)}
          </option>
        ))}
      </select>
      </section>
      <p> Years after partial retirement: {dateDifference(partialRetirementDate, selectedDate, 'year')}</p>
    </div>
  );
};

export default DateIncrementer;
